module.exports = __webpack_public_path__ + "static/media/n24.7794c05c.jpg";